<template>
  <div class="flex_box">
    <div class="diag-title">
      <div class="imgs">
        <div class="img-left">
          <img :src="currentDialog.avatar" alt="">
          <div>
            <div class="name">
              <div class="user-name" @click.stop="handleUsernameClick">
                {{ currentDialog.userName }}
              </div>
              <div class="isPoint">
                {{
                  currentDialog.source == 1
                  ? "小程序"
                  : "后台"
                }}
              </div>
            </div>
            <div class="phone">{{ currentDialog.phone }}</div>
          </div>
        </div>
        <!-- <el-button @click="handleReserveDetailClick(currentDialog)" type="text">订单详情></el-button> -->
        <el-button  @click.stop="handleUsernameClick" type="text">会员详情></el-button>
      </div>
    </div>
    <p class="plan" :style="currentDialog.matchingScheme?'opacity: 10;':'opacity: 0;'">匹配方案：{{ currentDialog.matchingScheme }}</p>
    <el-popover
      placement="top-start"
      :width="300"
      trigger="hover"
      content="实时展示用户最近10条预约爽约率，最近10条预约的爽约次数➗10"
    >
      <template #reference>
        <p class="plan">爽约率<el-icon><QuestionFilled /></el-icon>：{{currentDialog.breachRate||0}}%</p>
      </template>
    </el-popover>
    <p class="plan">预约时间：{{ currentDialog.startTime }} - {{ currentDialog.endTime }}</p>
    <div class="diag-select" v-if="currentDialog.appStatus != 6">
      <el-select popper-class="eloption" :popper-append-to-body="true" :disabled="currentDialog.appStatus==2||currentDialog.appStatus==4" v-model="confirmAppParamsCopy.roomId" placeholder="选择房间" size="small" @change="roomChage">
        <el-option v-for="item in roomOptions" :key="item.roomId" :label="item.roomNo" :value="item.roomId"  :disabled="!item.enabled" />
      </el-select>
      <el-select  popper-class="eloption" :disabled="currentDialog.appStatus==2||!confirmAppParamsCopy.roomId||currentDialog.appStatus==4" v-model="confirmAppParamsCopy.bed" size="small" placeholder="选择床位">
        <el-option v-for="item in bedOptions" :key="item.bedId" :label="item.bedId" :value="item.bedId" :disabled="!item.enabled"/>
      </el-select>

    </div>
    <div class="diag-select" style="justify-content: flex-start;align-items:center;" v-if="!currentDialog.hasSource">
      客户来源：
      <el-select popper-class="eloption" v-model="confirmAppParamsCopy.customerSourceId" size="small" placeholder="选择来源">
        <el-option v-for="item in sourceList" :key="item.customerSourceId" :label="item.customerSourceName" :value="item.customerSourceId"/>
      </el-select>
    </div>
    

    <!--订单信息 1待到店2已到店3已开单4已完成5已取消6已退款-->
    <div class="dialog-footer">
      <el-button v-has="'board:delete'" v-if="currentDialog.appStatus == 1" @click="cancelAppAction">
        取消预约
      </el-button>
      <el-button v-if="currentDialog.appStatus == 1" type="primary" @click="confirmAppAction">
        确认到店
      </el-button>
      <el-button v-if="currentDialog.appStatus == 2" type="success" @click="makeABillAction">开单</el-button>
      <el-button v-if="currentDialog.appStatus == 2" type="warning" @click="handleOpenKaikaClick">开卡</el-button>
      <el-button v-else type="warning" @click="handleOpenKaikaClick">开卡</el-button>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, watchEffect, reactive ,computed} from 'vue'
import { COMPANY_ID } from '@/common/constant'
import { getCustomerInfoList, addCustomerInfo, cancelOccupancys } from '@/service/main/reserve'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from "element-plus"
import {OccupyType} from '../config/occupyType.js'
import dayjs from 'dayjs'
import { customerSourceList } from '@/service/main/customer/index.js'
export default defineComponent({
  props: {
    currentDialog: {
      type: Object
    },
    roomOptions: {
      type: Array
    }
  },
  emits: ['makeABillAction', 'confirmAppAction', 'handleReserveDetailClick', 'cancelOccupancy','cancelAppAction'],
  setup (props, { emit }) {
    const store = useStore()
    const router = useRouter()
    const bedOptions = ref([])
    const confirmAppParamsCopy = reactive({
      // appNo: "",
      // companyId: COMPANY_ID,
      "roomId": "",
      // "arvTime": "",
      // "arvKind": "1", // 1.本人，2他人 默认1
      // "arvPerson": "",
      "bed": "",
      customerSourceId:null
    })
    const OccupyTypeOptions = new OccupyType().toObjectArray();
    const occupyForm =computed(() => props.currentDialog)
    const handleReserveDetailClick = (currentDialog) => {
      emit("handleReserveDetailClick", currentDialog)
    }
    const roomChage = (e) => {
      if ( !(props.roomOptions&&props.roomOptions.length)) return;
      confirmAppParamsCopy.bed=""
      const index = props.roomOptions.findIndex(r => r.roomId == e)
      bedOptions.value = props.roomOptions[index].bedList
    }
    const confirmAppAction = () => {
      emit("confirmAppAction", confirmAppParamsCopy)
    }
    const makeABillAction = () => {
      emit("makeABillAction")
    }
    const cancelAppAction = () => {
      emit("cancelAppAction", props.currentDialog.id)
    }
    const reserveRemarkList = ref([])

    const sourceList = ref([])
    const getDataList = async () => {
        let res = await customerSourceList()
        sourceList.value = res.data
    }
        
    const initPage = async () => {
      if (!props.currentDialog.isOccupancy) {
        const { data } = await getCustomerInfoList(props.currentDialog.userId)
        reserveRemarkList.value = data.list
      }
      getDataList()
    }
    initPage()

    const memo = ref("")
    const handleSubmitGenjinClick = async () => {
      if (!memo.value.trim()) return
      const { orderNo } = props.currentDialog
      let obj = {
        orderNo,
        memo: memo.value
      }
      await addCustomerInfo(obj)
      initPage()
      memo.value = ""
    }

    const handleUsernameClick = () => {
      let { userId, phone } = props.currentDialog
      router.push({
        path: "/main/customer/detail",
        query: {
          userId,
          phone: phone
        }
      })
    }
    const handleOpenKaikaClick = () => {
      let { userId, phone , empId , empName ,shopId ,userName} = props.currentDialog
      router.push({
        path: '/main/order/openCard',
        query: {
          userId: userId,
          phone: phone,
          empId,
          empName,
          shopId,
          username:userName
        }
      })
    }

    const cancelOccupancy = async () => {
      const res = await cancelOccupancys(props.currentDialog.occupancyNo)
      if (res.code == 0) {
        ElMessage({
          message: '操作成功!',
          type: 'success',
        })
        emit('cancelOccupancy')
      }
    }

    watchEffect(() => {
      const { isOccupancy,bed, roomId,customerSourceId } = props.currentDialog
      if (!isOccupancy) {
        if (roomId) roomChage(roomId)
        Object.assign(confirmAppParamsCopy, {
          bed: bed == 0 ? "" : bed,
          roomId: roomId == 0 ? "" : roomId,
          id:props.currentDialog.id,
          customerSourceId:customerSourceId?customerSourceId:null
        })
      }
      initPage()
    })
    return {
      memo,
      confirmAppParamsCopy,
      handleReserveDetailClick,
      roomChage,
      bedOptions,
      confirmAppAction,
      makeABillAction,
      handleSubmitGenjinClick,
      reserveRemarkList,
      handleUsernameClick,
      handleOpenKaikaClick,
      cancelOccupancy,
      cancelAppAction,
      occupyForm,
      OccupyTypeOptions,
      sourceList
    }
  }
})
</script>
<style lang="less" scoped>
.flex_box{
  // display: flex;
  // flex-direction: column;
  // justify-content: space-around;
  // height: 300px;
}
.isPoint {
  flex-shrink: 0;
  margin-left: 6px;
  width: 50px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid #fd678b;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fd678b;
  line-height: 16px;
  text-align: center;
}

.current-tips {
  color: rgba(80, 80, 80, 1);
  background-color: rgba(239, 239, 239, 1);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0;

  div {
    line-height: 30px;
    text-align: center;
  }
}

.imgs {
  display: flex;
  justify-content: space-between;

  .user-name {
    cursor: pointer;
    color: rgb(64, 158, 255);
  }

  .name {
    color: rgba(80, 80, 80, 1);
    font-size: 16px;
    display: flex;
    align-items: center;
  }

  .phone {
    color: rgba(80, 80, 80, 1);
    font-size: 14px;
    margin-top: 4px;
  }

}

.img-left {
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.diag-title {
  line-height: 30px;
  width: 380px;
  margin: 0px auto;
  padding-top: 25px;
}
.plan{
  width: 380px;
  margin: 12px auto 0;
  font-size: 14px;
}

.diag-select {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
  padding: 0 15px;

  .el-select {
    // margin-right: 5px;
  }
}

.dialog-footer {
  margin-top: 50px;
  display: flex;
  justify-content: space-around;
}
</style>